import { render } from "./download.vue?vue&type=template&id=8dfc34d6&scoped=true&ts=true"
import script from "./download.vue?vue&type=script&lang=ts&setup=true"
export * from "./download.vue?vue&type=script&lang=ts&setup=true"

import "./download.vue?vue&type=style&index=0&id=8dfc34d6&lang=scss&scoped=true"
import "./download.vue?vue&type=style&index=1&id=8dfc34d6&lang=scss"

import exportComponent from "/spug/spug_api/repos/119_10566_20260928180206/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dfc34d6"],['__file',"src/views/coordinate/download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8dfc34d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8dfc34d6', __exports__)) {
    console.log('reload')
    api.reload('8dfc34d6', __exports__)
  }
  
  module.hot.accept("./download.vue?vue&type=template&id=8dfc34d6&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('8dfc34d6', render)
  })

}


export default __exports__